import img1 from '../assets/images/new-arrival1.png'
import img2 from '../assets/images/new-arrival2.png'
import img3 from '../assets/images/new-arrival3.png'
import img4 from '../assets/images/new-arrival4.png'
import img5 from '../assets/images/best-seller1.png'
import img6 from '../assets/images/best-seller2.png'
import img7 from '../assets/images/best-seller3.png'
import img8 from '../assets/images/best-seller4.png'
import img9 from '../assets/images/special-offer1.png'
import img10 from '../assets/images/special-offer2.png'
import img11 from '../assets/images/special-offer3.png'
import img12 from '../assets/images/special-offer4.png'

export const productData = [
    {
       id:1,
       name: 'Round Table Clock',
       image: img1,
       rating: 4.5,
       brand: "Zara",
       color1:'black',
       color2: ["black","white", "red", "gray"],
       price: 44.00,
       feature: "Arrivals",
    },
    {
        id:2,
        name: 'Smart Watch',
        image: img2,
        rating: 4.5,
        brand: "Zara",
        color1:'black',
        color2: ["black","white", "red", "gray"],
        price: 250.00,
        feature: "Arrivals",
     },
     {
        id:3,
        name: 'cloth Basket',
        image: img3,
        rating: 4.5,
        brand: "Zara",
        color1:'mixed',
        color2: ["black","white", "red", "gray"],
        price: 80.00,
        feature: "Arrivals",
     },
     {
        id:4,
        name: 'Funny toys for babies',
        image: img4,
        rating: 4.5,
        brand: "Zara",
        color1:'mixed',
        color2: ["black","white", "red", "gray"],
        price: 30.00,
        feature: "Arrivals",
     },
     {
        id:5,
        name: 'Flower Base',
        image: img5,
        rating: 4.5,
        brand: "Zara",
        color1:'mixed',
        color2: ["black","white", "red", "gray"],
        price: 34.00,
        feature: "Bestsellers",
     },
     {
        id:6,
        name: 'New Backpack',
        image: img6,
        rating: 4.5,
        brand: "Zara",
        color1:'gray',
        color2: ["black","white", "red", "gray"],
        price: 180.00,
        feature: "Bestsellers",
     },
     {
        id:7,
        name: 'Household materials',
        image: img7,
        rating: 4.5,
        brand: "Zara",
        color1:'mixed',
        color2: ["black","white", "red", "gray"],
        price: 25.00,
        feature: "Bestsellers",
     },
     {
        id:8,
        name: 'Travel Bag',
        image: img8,
        rating: 4.5,
        brand: "Zara",
        color1:'black',
        color2: ["black","white", "red", "gray"],
        price: 220.00,
        feature: "Bestsellers",
     },
     {
      id:9,
      name: 'Cap for Boys',
      image: img9,
      rating: 4.5,
      brand: "Zara",
      color1:'white',
      color2: ["black","white", "red", "gray"],
      price: 35.00,
      feature: "offer",
   },
   {
      id:10,
      name: 'Tea Table',
      image: img10,
      rating: 4.5,
      brand: "Zara",
      color1:'gray',
      color2: ["black","white", "red", "gray"],
      price: 180.00,
      feature: "offer",
   },
   {
      id:11,
      name: 'Headphones',
      image: img11,
      rating: 4.5,
      brand: "Zara",
      color1:'red',
      color2: ["black","white", "red", "gray"],
      price: 25.00,
      feature: "offer",
   },
   {
      id:12,
      name: 'Sun glasses',
      image: img12,
      rating: 4.5,
      brand: "Zara",
      color1:'black',
      color2: ["black","white", "red", "gray"],
      price: 250.00,
      feature: "offer",
   },
   {
      id:13,
      name: 'Round Table Clock',
      image: img1,
      rating: 4.5,
      brand: "Zara",
      color1:'black',
      color2: ["black","white", "red", "gray"],
      price: 44.00,
   },
   {
       id:14,
       name: 'Smart Watch',
       image: img2,
       rating: 4.5,
       brand: "Zara",
       color1:'black',
       color2: ["black","white", "red", "gray"],
       price: 250.00,

    },
    {
       id:15,
       name: 'cloth Basket',
       image: img3,
       rating: 4.5,
       brand: "Zara",
       color1:'mixed',
       color2: ["black","white", "red", "gray"],
       price: 80.00,
 
    },
    {
       id:16,
       name: 'Funny toys for babies',
       image: img4,
       rating: 4.5,
       brand: "Zara",
       color1:'mixed',
       color2: ["black","white", "red", "gray"],
       price: 30.00,

    },
    {
       id:17,
       name: 'Flower Base',
       image: img5,
       rating: 4.5,
       brand: "Zara",
       color1:'mixed',
       color2: ["black","white", "red", "gray"],
       price: 34.00,
 
    },
    {
       id:18,
       name: 'New Backpack',
       image: img6,
       rating: 4.5,
       brand: "Zara",
       color1:'gray',
       color2: ["black","white", "red", "gray"],
       price: 180.00,

    },
    {
       id:19,
       name: 'Household materials',
       image: img7,
       rating: 4.5,
       brand: "Zara",
       color1:'mixed',
       color2: ["black","white", "red", "gray"],
       price: 25.00,

    },
    {
       id:20,
       name: 'Travel Bag',
       image: img8,
       rating: 4.5,
       brand: "Zara",
       color1:'black',
       color2: ["black","white", "red", "gray"],
       price: 220.00,
    },
    {
     id:21,
     name: 'Cap for Boys',
     image: img9,
     rating: 4.5,
     brand: "Zara",
     color1:'white',
     color2: ["black","white", "red", "gray"],
     price: 35.00,
  },
  {
     id:22,
     name: 'Tea Table',
     image: img10,
     rating: 4.5,
     brand: "Zara",
     color1:'gray',
     color2: ["black","white", "red", "gray"],
     price: 180.00,

  },
  {
     id:23,
     name: 'Headphones',
     image: img11,
     rating: 4.5,
     brand: "Zara",
     color1:'red',
     color2: ["black","white", "red", "gray"],
     price: 25.00,
    
  },
  {
     id:24,
     name: 'Sun glasses',
     image: img12,
     rating: 4.5,
     brand: "Zara",
     color1:'black',
     color2: ["black","white", "red", "gray"],
     price: 250.00,
     
  },
]